export const getModuleIdsByBuiltInType = ({
  editorStateSelectors
}) => {
  const {
    selectModuleIdsByBuiltInType
  } = editorStateSelectors;
  return selectModuleIdsByBuiltInType();
};